import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const DashBoardModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=g-KQIZGfeh0&ab_channel=apadua" />
);

export default DashBoardModal;
